import React from "react";
import clsx from "clsx";

import "./tools-tabs.css";

import WComponent from "../../../common/WComponent";

class ToolsTabs extends WComponent {
	onTabClicked = ({ tab }) => {
		if (tab.disabled) return;
		this.props.onSelect(tab.key);
	};

	renderCount = ({ tab }) => {
		if (tab.count === undefined || tab.count === null) return null;

		const isZero = tab.count === 0;
		return (
			<span className={clsx("tk-tabs__count", isZero && "tk-tabs__count--zero", !isZero && tab.countTone && `tk-tabs__count--${tab.countTone}`)}>
				{tab.count}
			</span>
		);
	};

	render() {
		const { tabs, activeKey, subordinate, segmented } = this.props;

		return (
			<div className={clsx("tk-tabs", subordinate && "tk-tabs--sub", segmented && "tk-tabs--segmented")} role="tablist">
				{tabs.map(tab => (
					<button
						key={tab.key}
						type="button"
						role="tab"
						aria-selected={activeKey === tab.key}
						title={tab.title}
						disabled={!!tab.disabled}
						className={clsx("tk-tabs__tab", activeKey === tab.key && "tk-tabs__tab--active")}
						onClick={() => this.onTabClicked({ tab })}
					>
						{tab.icon && <span className="tk-tabs__icon">{tab.icon}</span>}
						{tab.label}
						{this.renderCount({ tab })}
					</button>
				))}
			</div>
		);
	}
}

export default ToolsTabs;
